import React, { useState, useRef, useEffect } from 'react';
import styled from 'styled-components';
import { dateToPeriodLabel } from '../reports/weeklyReports';
import { CustomTable, rateFormat, addCurrency, restoreCharge, addCharge, addCustomJob } from './tables';
import { obtainBonusReimDeducValues, TableWrapper, isPerMileAdjustment, perMileDollarAmount, perMileRowLabel, signedWeeklyRate } from './tableTemplate';
import { MdOutlinePlaylistRemove, MdRestartAlt } from "react-icons/md";
import { addPopup, addNotification } from '../../supplementary_components/store';
import { ConfirmationDialogue } from '../../general_components/forms/ConfirmationDialogue';
import { sendRequest, API_ROOT } from '../../supplementary_components/requests';
import { resolveStatementAddLoadRate } from '../../supplementary_components/driverPayoutUtils';
import { driverPaymentTypeFormatter } from '../drivers/driverAddConf';
import { getDefaultCustomJob } from './jobsTableByPaymentTrype';
import { LoadingIcon } from '../../supplementary_components/loading_icon';
import { statusFormatter } from './statements';
import { IoClose } from "react-icons/io5";
import { FaChevronDown, FaChevronUp, FaChevronLeft, FaChevronRight, FaExclamationCircle } from "react-icons/fa";
import { CustomTooltip } from '../../general_components/content_management/reusableItems/tooltips';
import { TailSpin } from 'react-loading-icons'
import { generateShortId } from '../../supplementary_components/supplementaryMethods';
import styles from './statements.module.scss'
import { AddButton } from '../../general_components/content_management/reusableItems/buttons';
import { MdOutlineEditNote } from "react-icons/md";
import { CustomAddForm } from '../../general_components/forms/CustomAddForm';

const SingleStatement = styled.div`
    border-radius:0.5rem;
    border:thin solid var(--lighter-gray);
    background:var(--bg);;
    position:relative;
    &>.statementContent{
        margin-top:0.5rem;
        padding:0rem 1rem;
        &>.statementHeader{
            display:flex;
            align-items:center;
            background-color:var(--extra-light-gray);
            padding:0.5rem 2rem;
            &>table{
                border-collapse: separate;
                border-spacing: 0 1rem; 
                width:85%;
                &>tbody>tr{
                    &>td{
                        font-size:1.1rem;
                    }
                    &>.lbl{
                        color:var(--light-gray);
                    }
                    &>:not(.lbl){
                        color:var(--dark-gray);
                        font-weight:600;
                    }
                }
            }
            &>div{
                margin:0 0 0 auto;
                white-space:pre-wrap;
                text-align:right;
                font-size:1.1rem;
                font-weight:600;
                color:var(--dark-gray);
            }
        }
        &>.additionalTables{
            display:grid;
            gap:1rem;
            grid-template-columns: 0.8fr 20% 1.2fr;
            margin-top:1rem;
            padding-bottom:2rem;
            overflow:visible;
        }
    }
`
const Actions = styled.div`
    position: relative;
    &>.actionsButton{
        font-weight:600;
        -moz-user-select: none;
        -khtml-user-select: none;
        -webkit-user-select: none;
        padding:0.4rem 1rem;
        background: var(--lighter-gray);
        border-radius:0.4rem;
        color: var(--gray);
        &>svg{
            margin:0 -0.3rem -0.2rem 0;
        }
    }
    &:not(.editable){
        opacity: 0.5;
        pointer-events: none;
    }
    &.editable{
        opacity: 1.0;
        pointer-events: auto;
        &>svg{
            height:1.4rem;
            width:1.4rem;
            color:var(--gray);
            cursor:pointer;
        }
        &>.actionsButton{
            cursor:pointer;
            
            :hover{
                background: var(--main-color);
                color:var(--bg);
            }
        }
        
    }
    &>.actionsContent{
        display:none;
        z-index:1;
        position:absolute;
        right:0;
        background-color:var(--bg);
        box-shadow:var(--on-hover-visible-object-shadow);
        border-radius:0.4rem;
        padding:0.4rem 0;
        &>div{
            font-weight:600;
            -moz-user-select: none;
            -khtml-user-select: none;
            -webkit-user-select: none;
            &:not(.disabled){
                &:not(.removeButton){
                    color:var(--gray);
                }
                &.removeButton{
                    color:var(--alert-color);
                }
                cursor:pointer;
                :hover{
                    background:var(--extra-light-gray);
                }
            }
            &.disabled{
                color:var(--lighter-gray);
            }
            font-size:1.1rem;
            padding:0.5rem 1.2rem;
        }
    }
`
const Header = styled.div`
    display:flex;
    justify-content:end;
    align-items:center;
    padding:1rem;
    background-color:var(--extra-light-gray);
    border-radius: 0.5rem 0.5rem 0rem 0rem;
    &>div{
        margin-left:2rem;
    }
    &>div:not(.actions){
        color:var(--light-gray);
        font-weight:600;
        font-size:1.1rem;
        position:relative;

        &>svg{
            color:var(--gray);
            &:not(.closeButton, .editNoteButton){
                ${props => props.$hasDismissedCharges ? `
                    cursor:pointer;
                    opacity:1.0;
                `:`opacity:0.3;`}
            }
            &.closeButton, &.editNoteButton{
                opacity:0.5;
                cursor:pointer;
                opacity:1.0;
            }
            margin-bottom:-0.2rem;
            width:1.5rem;
            height:1.5rem;
        }
        &>#dismissedChargesList{
            display:none;
            padding:1rem;
            position:absolute;
            right:-100%;
            background:var(--bg);;
            z-index:3;
            box-shadow: var(--on-hover-visible-object-shadow);
            border-radius:0.4rem;
            &>:not(:first-child){
                margin-top:0.6rem;
            }
            &>div{
                width:100%;
                color: var(--gray);
                display:flex;
                align-items:center;
                &>span{
                    margin-right:1rem;
                }
                &>svg{
                    cursor:pointer;
                    margin:auto 0 auto auto;
                    width:1.3rem;
                    height:1.3rem;
                }
            }
        }
        
    }
`
const ButtonsPannel = styled.div`
    width:100%;
    padding:1rem;
    border-top:thin solid var(--lighter-gray);
    position:relative;
    height:4.6rem;
    &>div{
        -moz-user-select: none;
        -khtml-user-select: none;
        -webkit-user-select: none;
        position:absolute;
        bottom:1rem;
        right:3rem;
        width:13rem;
        &>div{
            font-weight:700;
            font-size:1.15rem;
            &:not(:last-child){
                border-left:0.2rem solid var(--main-color);
                border-right:0.2rem solid var(--main-color);
                display:none;
                background:var(--bg);;
                &.disabled{
                    color:rgba(var(--successGreenRGB), 0.5);
                }
                &:not(.disabled){
                    cursor:pointer;
                    :hover{
                        background:var(--main-color);
                        color:white;
                    }
                    color:var(--main-color);
                }
            }
            &:first-child{
                border-top:0.2rem solid var(--main-color);
                border-radius:0.4rem 0.4rem 0 0;
            }
            &:last-child{
                text-align:center;
                color:white;
                background:${props => props.$buttonDisabled ? "rgba(var(--successGreenRGB), 0.5)" : "var(--main-color)"};
                
                border-radius:0.4rem;
                &.non-loading{
                    &>:first-child{
                        margin:0 -0.5rem -0.13rem 0.5rem;
                    }
                    &>:last-child{
                        display:none;
                    }
                }
                &.loading{
                    background:rgba(var(--successGreenRGB), 0.5);
                    &>:first-child{
                        display:none;
                    }
                    &>:last-child{
                        margin:0 -0.5rem 0 0.5rem;
                    }
                }
            }
            padding: 0.7rem 1rem;
            
        }
        &:not(.loading){
            ${props => props.$buttonDisabled ? '' :`
                :hover{
                    &>div{
                        &:not(:last-child){
                            display:block;
                        }
                        &:last-child{
                            border-radius:0 0 0.4rem 0.4rem;
                        }
                    }
                }
            `}
        }
    }
`
const MileageInfoBox = styled.div`
    &>.mileageIcon{
        position:relative;
        display:inline-block;
        margin-left:0.4rem;
        cursor:pointer;
        &>svg{
            color:var(--lighter-gray);
            width:1rem;
            height:1rem;
            margin-bottom:-0.1rem;
        }
        .tooltip{
            font-weight:500;
            line-height:1.5rem;
            .tooltipContentWrapper>span{
                background-color:var(--bg);
                box-shadow:var(--on-hover-visible-object-shadow);
            }
            .arrowEffect{
                background-color:var(--bg);
            }
            .tooltipContentText{
                color:var(--light-gray);
            }
        }
        &:hover{
            .tooltip{
                visibility: visible;
            }
        }
    }
`
function formatMiles(value){
    return Number(value || 0).toLocaleString();
}
function sumLoadRates(statement) {
    return (statement.jobsArray || []).reduce(
        (sum, job) => addCurrency(sum, job.loadRate),
        0
    );
}
function jobsTableSummaryColumns(statement) {
    const payoutColumn = {
        width: "10%",
        alignment: "right",
        customFormat: rateFormat,
        calculation: () => statement.jobsGrandTotal
    };
    if (statement.paymentType === "Percentage") {
        return [
            { width: "75%", alignment: "right", calculation: () => "Grand Total:" },
            {
                width: "15%",
                alignment: "right",
                customFormat: rateFormat,
                calculation: () => sumLoadRates(statement)
            },
            payoutColumn
        ];
    }
    if (statement.paymentType === "PerMile") {
        return [
            { width: "83.34%", alignment: "right", calculation: () => "Grand Total:" },
            {
                width: "6.66%",
                alignment: "center",
                calculation: () => {
                    const miles = (statement.jobsArray || []).reduce(
                        (sum, job) => sum + (Number(job.deadhead) || 0) + (Number(job.mileage) || 0),
                        0
                    );
                    return `${formatMiles(Math.round(miles))} mi`;
                }
            },
            payoutColumn
        ];
    }
    return [
        { width: "90%", alignment: "right", calculation: () => "Grand Total:" },
        payoutColumn
    ];
}
const TruckMileageInfo = ({truckMileage}) => {
    const { coveredMileage, adjustmentAmount, startOdometer, endOdometer } = truckMileage;
    const lines = [];
    if(endOdometer !== undefined && endOdometer !== null){
        lines.push(`Start Odometer: ${formatMiles(startOdometer)}`);
        lines.push(`End Odometer: ${formatMiles(endOdometer)}`);
    }
    if(adjustmentAmount){
        lines.push(`Adjustment: ${formatMiles(adjustmentAmount)}`);
    }
    return <MileageInfoBox>
        Total Mileage: {formatMiles(coveredMileage)}
        <span className="mileageIcon">
            <FaExclamationCircle />
            <CustomTooltip info={lines.length ? lines.join("\n") : "No odometer data available"} marginTop={"0.6rem"} xDisposition={"-1.5rem"} />
        </span>
    </MileageInfoBox>
}
const NoLoads = styled.div`
    width:100%;
    text-align:center;
    font-weight:600;
    font-size:2.5rem;
    color:var(--extra-light-gray);
    padding:4rem 0;
`
function processAdditionalDataLabel(label){
    if(label === "ipassId"){
        return "I-Pass ID";
    }else if(label === "pikePassId"){
        return "Pike-Pass ID";
    }else if(label === "mileage"){
        return "Mileage";
    }
    return label;
}
export const SingleStatementContentManager = ({crntStatement, companyData, close, changeStatementStatus, updateStatementNote}) => {
    // NEW IMPLEMENTATION: Cache-based statement management for switching between statements
    // Cache to store all loaded statements by ID (null means component should unmount)
    const [statementsCache, setStatementsCache] = useState(new Map([[crntStatement.id, crntStatement]]));
    // Track edited state per statement ID
    const [editedStates, setEditedStates] = useState(new Map([[crntStatement.id, false]]));
    // Current statement ID being viewed
    const [currentStatementId, setCurrentStatementId] = useState(crntStatement.id);
    const [loading, setLoading] = useState(false);
    const statementRef = useRef(null);
    const dismissedChargesContainer = useRef(null);
    const actionsContainer = useRef(null);
    
    // Get current statement from cache (will be undefined if cache is null)
    const currentStatement = statementsCache?.get(currentStatementId);
    const statementEdited = editedStates.get(currentStatementId) || false;
    const isEditable = currentStatementId === crntStatement.id;
    
    // Function to load a statement (from cache or backend)
    const loadStatement = (statementId) => {
        if (!statementsCache) return; // Component is being unmounted
        // If already in cache, just switch to it
        if (statementsCache.has(statementId)) {
            setCurrentStatementId(statementId);
            return;
        }
        
        // Otherwise, fetch from backend
        setLoading(true);
        const url = API_ROOT + `statements/byId?id=${statementId}`;
        sendRequest("GET", url, null, (res) => {
            if (!res || !res.id) {
                addNotification({message: "Invalid statement data received", type: 'alert'});
                setLoading(false);
                return;
            }
            setStatementsCache(prev => {
                if (!prev) return null; // Maintain null state if already null
                const newCache = new Map(prev);
                newCache.set(statementId, res);
                return newCache;
            });
            setEditedStates(prev => {
                const newStates = new Map(prev);
                if (!newStates.has(statementId)) {
                    newStates.set(statementId, false);
                }
                return newStates;
            });
            setCurrentStatementId(statementId);
            setLoading(false);
        }, (err) => {
            console.error('Error loading statement:', err);
            setLoading(false);
            addNotification({message: err?.customError || "Failed to load statement", type: 'alert'});
        });
    };
    
    // Navigation handlers
    const navigateToPrevious = (e) => {
        e?.preventDefault();
        e?.stopPropagation();
        if (!statementsCache) return; // Component is being unmounted
        const stmt = statementsCache.get(currentStatementId);
        if (stmt?.previousStatementId) {
            loadStatement(stmt.previousStatementId);
        }
    };
    
    const navigateToNext = (e) => {
        e?.preventDefault();
        e?.stopPropagation();
        if (!statementsCache) return; // Component is being unmounted
        const stmt = statementsCache.get(currentStatementId);
        if (stmt?.nextStatementId) {
            loadStatement(stmt.nextStatementId);
        }
    };
    
    // OLD IMPLEMENTATION (commented out):
    // const [currentStatement, setCurrentStatement] = useState(crntStatement);
    // const [statementEdited, setStatementEdited] = useState(false);
    // const [loading, setLoading] = useState(false);
    // const statementRef = useRef(null);
    // const dismissedChargesContainer = useRef(null);
    // const actionsContainer = useRef(null); 
    // const isEditable = currentStatement.id === crntStatement.id;

    // NEW: Update statement in cache and optionally mark as edited
    function _setCurrentStatement(newSttmnt, options = {}){
        const { markEdited = true } = options;
        if (!statementsCache) return; // Component is being unmounted
        if (markEdited) {
            setEditedStates(prev => {
                const newStates = new Map(prev);
                newStates.set(currentStatementId, true);
                return newStates;
            });
        }
        setStatementsCache(prev => {
            if (!prev) return null; // Maintain null state if already null
            const newCache = new Map(prev);
            newCache.set(currentStatementId, newSttmnt);
            return newCache;
        });
    }
    
    // NEW: Update statement status in cache
    function _changeStatementStatus(id, newStatus, adjustmentsGrandTotal, totalBonuses, totalDeductions, totalReimbursements, jobsGrandTotal){
        
        if (!statementsCache) return; // Component is being unmounted
        setStatementsCache(prev => {
            if (!prev) return null; // Maintain null state if already null
            const newCache = new Map(prev);
            const updatedStatement = newCache.get(id);
            if (updatedStatement) {
                updatedStatement.status = newStatus;
                updatedStatement.adjustmentsGrandTotal = adjustmentsGrandTotal ?? updatedStatement.adjustmentsGrandTotal;
                if (jobsGrandTotal != null) updatedStatement.jobsGrandTotal = jobsGrandTotal;
                updatedStatement.totalBonuses = totalBonuses ?? updatedStatement.totalBonuses;
                updatedStatement.totalDeductions = totalDeductions ?? updatedStatement.totalDeductions;
                updatedStatement.totalReimbursements = totalReimbursements ?? updatedStatement.totalReimbursements;
                newCache.set(id, updatedStatement);
            }
            return newCache;
        });
        changeStatementStatus(id, newStatus, adjustmentsGrandTotal, totalBonuses, totalDeductions, totalReimbursements, jobsGrandTotal);
    }
    
    // OLD IMPLEMENTATION (commented out):
    // function _setCurrentStatement(newSttmnt){
    //     setStatementEdited(true);
    //     setCurrentStatement(newSttmnt);
    // }
    // function _changeStatementStatus(id, newStatus, adjustmentsGrandTotal, totalBonuses, totalDeductions,  totalReimbursements){
    //     setCurrentStatement(prev => {
    //         return {...prev, status: newStatus, 
    //             adjustmentsGrandTotal: adjustmentsGrandTotal || prev.adjustmentsGrandTotal,
    //             totalBonuses: totalBonuses || prev.totalBonuses,
    //             totalDeductions: totalDeductions || prev.totalDeductions,
    //             totalReimbursements: totalReimbursements || prev.totalReimbursements,
    //         }
    //     });
    //     changeStatementStatus(id, newStatus, adjustmentsGrandTotal, totalBonuses, totalDeductions,  totalReimbursements);
    // }
    const handleClickOutside = (event) => {
        closeContainer(actionsContainer, event);
        closeContainer(dismissedChargesContainer, event);
    };
    function closeContainer(ref, event){
        if (ref.current && ref.current.style.display === "block" && (!event || !ref.current.parentElement.contains(event.target))) {
            ref.current.style.display = "none";
        }
    }
    useEffect(
        () => {
            document.addEventListener("mousedown", handleClickOutside);
            return () => {
                document.removeEventListener("mousedown", handleClickOutside);
            };
            // eslint-disable-next-line
        }, [currentStatement, statementEdited]
    );
    if(!currentStatement)return null;
    const payDate = new Date(currentStatement.period.endDate+" 00:00");
    payDate.setDate(payDate.getDate()+6);
    let shiftedBy = currentStatement['adjustmentsArray'].length;
    const adjustmentsArray = currentStatement['adjustmentsArray'].concat(currentStatement["paymentsArray"].filter(item => item.weeklyRate > 0));
    shiftedBy = adjustmentsArray.length - shiftedBy;
    adjustmentsArray.sort((a, b) => ("weeklyRate" in b) - ("weeklyRate" in a));
    let grandTotalAdjustments = 0;
    let finzalizable = currentStatement.status === "inReview" || statementEdited ? true : false;
    let hasBlockingIssues = false;
    for(let adjustment of adjustmentsArray){
        if("weeklyRate" in adjustment){
            grandTotalAdjustments += signedWeeklyRate(adjustment)
        }else if("amount" in adjustment){
            if(adjustment.status === "approved"){
                grandTotalAdjustments += adjustment["type"] === "charge" ? -adjustment.amount : adjustment.amount;
            }
            if(adjustment.status === "inReview" || adjustment.status === "pending"){
                finzalizable = false;
                hasBlockingIssues = true;
            }
        }
    }
    if (currentStatement.paymentType === "Percentage" && Array.isArray(currentStatement.jobsArray)) {
        for (const job of currentStatement.jobsArray) {
            if (job && job.loadRate == null) {
                finzalizable = false;
                hasBlockingIssues = true;
                break;
            }
        }
    }
    const needsFinalizeForDownload = currentStatement.status === "inReview" || statementEdited;
    const downloadLabel = hasBlockingIssues
        ? "Download (Req. Finalization)"
        : needsFinalizeForDownload
            ? "Finalize & Download"
            : "Download";
    currentStatement.adjustmentsGrandTotal = grandTotalAdjustments;
    if(!currentStatement.dismissedCharges)currentStatement.dismissedCharges=[];
    const statusObject = statusFormatter(currentStatement.status);
    function checkSendRequestStatus (jobId){
        setTimeout(() => {
            sendRequest("GET", API_ROOT+"statements/jobStatus?jobId="+jobId, null, (res)=>{
                if(Object.keys(res).length < 1){
                    checkSendRequestStatus(jobId);
                }else {
                    setLoading(false);
                    if(res["customMessage"] === "reloadPage"){
                        window.location.reload();
                    }else if(res[jobId][currentStatement.id]){
                        addNotification({message:`Statement Was Sent`, type:'success'});
                        _changeStatementStatus(currentStatement.id, "sent");
                    }else{
                        addNotification({message:`Something went wrong`, type:'alert'});
                    }
                }
            }, (e)=>{console.log(e)})                
        }, 500);
    }
    // NEW: Close statement with cache management
    function closeStatement(){
        const statementElement = document.getElementById(currentStatement.id);
        if (statementElement && statementElement.parentElement && statementElement.parentElement.parentElement) {
            const childCount = statementElement.parentElement.parentElement.childElementCount;
            if (childCount === 1) {
                // If this is the only statement, close the entire popup
                close();
                return;
            }
        }
        
        // Otherwise, close this SingleStatementContentManager by setting cache to null
        setStatementsCache(null);
    }
    
    // OLD IMPLEMENTATION (commented out):
    // function closeStatement(){
    //     setCurrentStatement(null);
    //     if(document.getElementById(currentStatement.id).parentElement.childElementCount === 1){
    //         close();
    //         return;
    //     }
    // }
    const statementActionProcess = (event)=>{
        const target = event.target;
        
        if(target.className.includes("disabled"))return;
        const name = target.getAttribute("name");
        closeContainer(actionsContainer);
        if(name === "recompile"){
            addPopup({
                content:ConfirmationDialogue,
                popupData: {
                    action:(postResultAction)=>{
                        sendRequest("POST", API_ROOT+"statements/regenerateStatement?statementId="+currentStatement.id, null, (res)=>{
                            changeStatementStatus(currentStatement.id, "inReview", undefined, undefined, undefined, undefined, res?.jobsGrandTotal);
                            // NEW: Update cache instead of setCurrentStatement
                            setStatementsCache(prev => {
                                if (!prev) return null; // Maintain null state if already null
                                const newCache = new Map(prev);
                                newCache.set(currentStatement.id, res);
                                return newCache;
                            });
                            setEditedStates(prev => {
                                const newStates = new Map(prev);
                                newStates.set(currentStatement.id, false);
                                return newStates;
                            });
                            // OLD: setCurrentStatement(res);
                            // OLD: setStatementEdited(false);
                            postResultAction(true);
                        }, (resp)=>{
                            postResultAction(true);
                            addNotification({message: resp.customError ||  `Something went wrong`, type:'alert'});
                        })
                    },
                    name:"Confirm",
                    formTitle:"Regenerate Statement",
                    submitTitle:"Continue",
                    method:"POST",
                    message:"All changes will be lost. Do you want to continue?"
                }, 
                postSuccessAction: ()=>{
                }, 
                EZCloseAllowed:true
            });
        }else{
            setLoading(true);

            const downloadPdf = () => {
                sendRequest(
                    "GET",
                    API_ROOT+"statements/pdf?id="+currentStatement.id,
                    null,
                    async (response)=>{
                        try {
                            const blob = await response.blob();
                            const filename = filenameFromContentDisposition(response.headers?.get?.("content-disposition"))
                                || statementPdfDownloadName(currentStatement);
                            triggerBlobDownload(blob, filename);
                        } catch (err) {
                            console.error("Failed to download statement PDF:", err);
                            addNotification({message:`Failed to Download Statement`, type:'alert'});
                        } finally {
                            setLoading(false);
                        }
                    },
                    ()=>{
                        addNotification({message:`Failed to Download Statement`, type:'alert'});
                        setLoading(false);
                    },
                    null,
                    null,
                    null,
                    true
                );
            };
            
            // Define the action logic (Send, MarkAsPaid, Delete)
            const performAction = () => {
                // name === send markAsPaid delete
                const jobId = generateShortId();
                const link = name === "send" ? "statements/send?companyId="+companyData.id+"&periodId="+currentStatement.period.id+"&jobId="+jobId : name === "markAsPaid" ? "statements/markAsPaid?companyId="+companyData.id+"&periodId="+currentStatement.period.id : "statements/delete?companyId="+companyData.id;
                
                sendRequest("POST", API_ROOT+link, null, (res)=>{
                    if(name === "send"){
                        if(res){
                            checkSendRequestStatus(jobId);
                        }
                    }else if(name === "markAsPaid"){
                        if(res[currentStatement.id]){
                            _changeStatementStatus(currentStatement.id, "paid");
                        }
                        setLoading(false);
                    }else{
                        if(res[currentStatement.id]){
                            changeStatementStatus(currentStatement.id, "remove");
                            closeStatement();
                        }
                        setLoading(false);
                    }
                }, ()=>{
                    setLoading(false); 
                }, [currentStatement.id]);
            };

            const finalizeThen = (afterFinalize) => {
                const link = 'statements/finalize?hasUnsavedChanges='+statementEdited;
                const payloadStatement = obtainBonusReimDeducValues(currentStatement);
                
                sendRequest("POST", API_ROOT + link, null, ()=>{
                    setEditedStates(prev => {
                        const newStates = new Map(prev);
                        newStates.set(currentStatement.id, false);
                        return newStates;
                    });
                    
                    addNotification({message:`Statement Finalized`, type:'success'});
                    _changeStatementStatus(currentStatement.id, "finalized", currentStatement.adjustmentsGrandTotal, payloadStatement.totalBonuses, payloadStatement.totalDeductions, payloadStatement.totalReimbursements, currentStatement.jobsGrandTotal);
                    
                    afterFinalize();
                }, ()=>{
                    addNotification({message:`Failed to Finalize`, type:'alert'});
                    setLoading(false);
                }, payloadStatement);
            };

            if (name === "download") {
                if (needsFinalizeForDownload) {
                    finalizeThen(downloadPdf);
                } else {
                    downloadPdf();
                }
            } else if (name === "send" && statementEdited) {
                finalizeThen(performAction);
            } else {
                performAction();
            }
        }
        
    }
    const saveAction = (event) =>{
        const target = event.target;
        const draftSave = target.innerText === "Save As Draft";
        // NEW: Compare IDs instead of object references
        if(draftSave && crntStatement.id === currentStatement.id && !statementEdited){
            return;
        }
        // OLD: if(draftSave && crntStatement === currentStatement){
        //     return;
        // }
        target.parentElement.className = "loading";
        target.parentElement.querySelector("#saveFinalizeButton").className = "loading";
        const link = draftSave ? 'statements/save' : 'statements/finalize?hasUnsavedChanges='+statementEdited;
        const payloadStatement = obtainBonusReimDeducValues(currentStatement);
        sendRequest("POST", API_ROOT + link, null, ()=>{
            // NEW: Update edited state in cache
            setEditedStates(prev => {
                const newStates = new Map(prev);
                newStates.set(currentStatement.id, false);
                return newStates;
            });
            // OLD: setCurrentStatement(res);
            // OLD: setStatementEdited(false);
            addNotification({message:draftSave?`Statement Saved`:`Statement Finalized`, type:'success'});
            if(draftSave){
                _changeStatementStatus(currentStatement.id, "inReview", undefined, undefined, undefined, undefined, currentStatement.jobsGrandTotal);
            }else{
                _changeStatementStatus(currentStatement.id, "finalized", currentStatement.adjustmentsGrandTotal, payloadStatement.totalBonuses, payloadStatement.totalDeductions, payloadStatement.totalReimbursements, currentStatement.jobsGrandTotal);
                if(target.innerText === "Finalize & Close"){
                    closeStatement()
                }
            }
            target.parentElement.className = "non-loading";
            target.parentElement.querySelector("#saveFinalizeButton").className = "non-loading";
        }, ()=>{
            addNotification({message:`Something went wrong`, type:'alert'});
            target.parentElement.className = "non-loading";
            target.parentElement.querySelector("#saveFinalizeButton").className = "non-loading";
        }, payloadStatement);
    }
    return <div className={styles.statementWrapper}>
    {/* NEW: Navigation buttons with onClick handlers */}
    {(currentStatement?.previousStatementId || (currentStatementId === crntStatement.id && crntStatement.previousStatementId)) ? 
        <div 
            className={`${styles.switchStatementButton} ${styles.leftButton}`}
            onClick={(e) => {
                navigateToPrevious(e);
            }}
            style={{ pointerEvents: 'auto', userSelect: 'none' }}
        >
            <FaChevronLeft />
        </div> 
        : null
    }
    {/* OLD: {crntStatement.previousStatementId ? <div className={`${styles.switchStatementButton} ${styles.leftButton}`}><FaChevronLeft /></div> : null} */}
    <SingleStatement id={currentStatement.id} ref={statementRef}  data-unsavedchanges={statementEdited} >
        {!isEditable ? <div className={styles.previewMode}>Preview Mode</div> : null}
        <LoadingIcon state={loading} height={statementRef.current ? statementRef.current.offsetHeight+"px" : "10rem"} />
        
        <Header $hasDismissedCharges={currentStatement.dismissedCharges.length>0}>
            {
                currentStatement.additionalData && typeof currentStatement.additionalData === 'object' ?
                Object.entries(currentStatement.additionalData).map(([key, value], index) => (
                    <div key={index}>
                        {processAdditionalDataLabel(key)}: {value}
                    </div>
                ))
                : null
            }
            <div>
                Payment Type: {driverPaymentTypeFormatter(currentStatement.paymentType)}
            </div>
            <div>
                {currentStatement.paymentType === "PerMile" ?
                `Per Mile Rate: ${rateFormat(currentStatement.driver.perMileRate)}`
                : currentStatement.paymentType === "Percentage" ?
                `Service Fee: ${((1-currentStatement.driver.percentageFromGross)*100).toFixed(2)}%`
                :`Per Week Salary: ${rateFormat(currentStatement.driver.salaryPerWeek)}`
                }   
                   
            </div>
            {currentStatement.truckMileage ? <TruckMileageInfo truckMileage={currentStatement.truckMileage} /> : null}
            <div>
                Status: <span style={{color:statusObject.color}}>{statusObject.title}</span>
            </div>
            <div>
                <MdOutlineEditNote className="editNoteButton" onClick={()=>{
                    const editing = currentStatement.statementNote ? true : false;
                    addPopup({
                        content:CustomAddForm,
                        popupData:{
                            action:(event, postResultAction)=>{
                                event.preventDefault();
                                const target = event.target;
                                const statementNote = target.querySelector("textarea[name='statementNote']").value;
                                sendRequest("POST", API_ROOT+"statements/addNote?statementId="+currentStatement.id, null, ()=>{
                                    _setCurrentStatement({ ...currentStatement, statementNote }, { markEdited: false });
                                    updateStatementNote(currentStatement.id, statementNote);
                                    postResultAction(true);
                                    addNotification({message:"Statement Note Added", type:'success'});

                                }, ()=>{
                                    postResultAction(false);
                                    addNotification({message:"Something went wrong", type:'alert'});
                                }, {note: statementNote})
                                
                            },
                            name:"Add",
                            formTitle:`${editing ? "Edit" : "Add"} Statement Note`,
                            submitTitle:`${editing ? "Save" : "Add"}`,
                            method:"POST",
                            columns: [{
                                label: "Statement Note",
                                name: "statementNote",
                                type:'textArea',
                                defaultValue: currentStatement.statementNote ? ()=>{return currentStatement.statementNote} : null,
                                rowCount: 5,
                            }]
                        }, 
                        EZCloseAllowed:true
                    });
                }} />
            </div>
            <div>
                <MdOutlinePlaylistRemove onMouseDown={(e)=>{
                    if(dismissedChargesContainer.current && dismissedChargesContainer.current.style.display !== "block" && currentStatement.dismissedCharges.length > 0){
                        dismissedChargesContainer.current.style.display = "block"; 
                    }
                }} /> 
                <div id="dismissedChargesList" ref={dismissedChargesContainer} >
                    {currentStatement.dismissedCharges.map((charge, index)=>{
                        console.log(charge);
                        return <div key={index}>
                            
                             <span>{`${isPerMileAdjustment(charge) ? perMileRowLabel(charge) : `${charge["title"] || charge["description"]}${"loadNumber" in charge ? `(${charge["loadNumber"]})` : ""}`}: ${rateFormat(isPerMileAdjustment(charge) ? perMileDollarAmount(charge) : (charge["amount"] || charge["weeklyRate"]))}`}</span>
                                <MdRestartAlt onClick={()=>{
                                    closeContainer(dismissedChargesContainer);
                                    restoreCharge(currentStatement, _setCurrentStatement, index, charge);
                                }} />
                        </div>
                    })}
                </div> 
            </div>
            <Actions className={`actions ${isEditable?"editable":"non-editable"}`}>
                <div className="actionsButton" onMouseDown={()=>{
                    if(actionsContainer.current){
                        if(actionsContainer.current.style.display !== "block"){
                            actionsContainer.current.style.display = "block";
                        }else{
                            actionsContainer.current.style.display = "none";
                        }
                    }
                    
                }} >Actions <FaChevronDown /></div>
                <div ref={actionsContainer} className="actionsContent">
                    <div name="recompile" onClick={statementActionProcess}>Recompile</div>
                    <div name="send" className={statusObject.title === "In Review" ? "disabled" : ""} onClick={statusObject.title === "In Review" ? null:statementActionProcess}>{statusObject.title !== "In Review" && statementEdited ? "Finalize & Send" : "Send"}</div>
                    <div name="download" className={hasBlockingIssues ? "disabled" : ""} onClick={hasBlockingIssues ? null : statementActionProcess}>{downloadLabel}</div>
                    <div name="markAsPaid" className={statusObject.title === "In Review" || statusObject.title === "Finalized" || statusObject.title === "Paid" ? "disabled" : ""} onClick={statementActionProcess}>Mark As Paid</div>
                    <div className="removeButton" name="delete" onClick={statementActionProcess}>Delete Statement</div>
                </div>
            </Actions>
            <div>
                <IoClose className="closeButton" onClick={()=>{
                    if(statementEdited){
                        addPopup({
                            content: ConfirmationDialogue,
                            popupData:{
                                action:(postResultAction)=>{
                                    closeStatement();
                                    postResultAction(true);
                                },
                                name: "Close",
                                formTitle:"Close Statement",
                                submitTitle:"Continue",
                                message:"You have unsaved changes. Are you sure you want to continue?",
                                postSuccessAction: ()=>{
                                },
                                EZCloseAllowed:true
                            }
                        });
                    }else{
                        closeStatement();
                    }
                }} />
            </div>
        </Header>
        <div className="statementContent">
            <div className="statementHeader">
                <table>
                    <tbody>
                        <tr>
                            <td className="lbl">
                                Name:
                            </td>
                            <td>
                                {`${currentStatement.driver.lastName}, ${currentStatement.driver.firstName} ${currentStatement.driver.middleName||''}`}
                            </td>
                            <td className="lbl">
                                Truck(s):
                            </td>
                            <td>
                                {currentStatement.truckNumbers.join(', ')}
                            </td>
                            <td className="lbl">
                                Period:
                            </td>
                            <td>
                                {dateToPeriodLabel(new Date(currentStatement.period.startDate+" 00:00"), true)}
                            </td>
                        </tr>
                        <tr>
                            <td className="lbl">
                                DBA:
                            </td>
                            <td>
                                {currentStatement.driver.dbaInfo ? JSON.parse(currentStatement.driver.dbaInfo)["dbaCompanyName"] : "N/A"}
                            </td>
                            <td className="lbl">
                                Trip#:
                            </td>
                            <td>
                                {currentStatement.tripNumber}
                            </td>
                            <td className="lbl">
                                Pay Day:
                            </td>
                            <td>
                            {
                                payDate.toLocaleDateString("en-US", { day: 'numeric', month: 'numeric', year: 'numeric' })
                            }
                            </td>
                        </tr>
                    </tbody>
                </table>
                <div className="companyInfo">
                    {
                        companyData ? 
                        `${companyData.companyName}\n${companyData.addressLine1}${(companyData.addressLine2 !== "" && companyData.addressLine2 !== null)? `\n${companyData.addressLine2}`  :""}\n${companyData.city}, ${companyData.state} ${companyData.postalCode}`
                        :
                        "Your Trucking Company Info"
                    }
                </div>
            </div>
            {currentStatement.jobsArray.length > 0 ?
            <CustomTable currentStatement={currentStatement} setCurrentStatement={_setCurrentStatement} tableName={"jobsArray"} tableSummaryConf={{headerPresent:false, tableSummary:true, customWidth: "99%", columns: jobsTableSummaryColumns(currentStatement)}} isEditable={isEditable} />
        
        : <NoLoads>NO LOADS IN THIS PERIOD</NoLoads>}
            {currentStatement.paymentType !== "Salary" ? <>
                <br />
                <AddButton customSize={"1.5rem"} action={()=>{
                    if(currentStatement.paymentType === "Percentage"){
                        addSpecificLoadToStatement(currentStatement, _setCurrentStatement, addCustomJob);
                    }else{
                        addCustomJob(currentStatement, _setCurrentStatement, getDefaultCustomJob(currentStatement.paymentType, currentStatement))}
                    }
                    
                    } 
                />
            </>:null}
            
            <div className="additionalTables">
                <div>
                    <CustomTable currentStatement={currentStatement} customDataset={adjustmentsArray} setCurrentStatement={_setCurrentStatement}  tableName={"adjustmentsArray"} tableSummaryConf={{headerPresent:false, tableSummary:true,  columns:[
                        {
                            width: "80%", 
                            alignment: "right",
                            calculation:()=>{return "Grand Total:"}
                        },
                        {
                            width: "20%", 
                            alignment: "right",
                            customFormat: rateFormat,
                            calculation:()=>{return currentStatement.adjustmentsGrandTotal}
                        }
                    ]}} shiftedBy={shiftedBy} addButton={
                        ()=>{addCharge(currentStatement, "adjustmentsArray", _setCurrentStatement, {title:"", description:"", amount:0, status:"approved", customAdjustment: true, cat: "bns"})}}  isEditable={isEditable} />
                    
                </div>
                <div></div>
                <div><CustomTable currentStatement={currentStatement} setCurrentStatement={_setCurrentStatement} tableName={"paymentsArray"} isEditable={isEditable} /></div>
                <div></div>
                <div></div>
                <div>
                <TableWrapper $finalTable={true}>
                    <tbody>
                        {currentStatement.paymentType === "Percentage" ? (
                        <tr>
                            <td>Total Gross:</td>
                            <td>{rateFormat(sumLoadRates(currentStatement))}</td>
                        </tr>
                        ) : null}
                        <tr>
                            <td>Total Payout:</td>
                            <td>{rateFormat(currentStatement.jobsGrandTotal)}</td>
                        </tr>
                        <tr>
                            <td >Total Adjustments:</td>
                            <td>{rateFormat(currentStatement.adjustmentsGrandTotal)}</td>
                        </tr>
                        <tr>
                            <td style={{padding: "0.8rem 8px", fontSize: "1.2rem", color:"var(--extra-dark-gray)"}}>Net Pay:</td>
                            <td style={{padding: "0.8rem 8px", fontSize: "1.2rem", color:"var(--extra-dark-gray)"}}>{rateFormat(addCurrency(currentStatement.jobsGrandTotal, currentStatement.adjustmentsGrandTotal))}</td>
                        </tr>
                    </tbody>
                </TableWrapper >
                    </div>
            </div> 
            
        </div>
        <ButtonsPannel $buttonDisabled={!statementEdited && !finzalizable} >
            <div>
                <div className={!statementEdited ? "disabled" : ""} onClick={statementEdited?saveAction:null}>Save As Draft</div>
                <div className={!finzalizable ? "disabled" : ""} onClick={finzalizable?saveAction:null}>Finalize</div>
                <div className={!finzalizable ? "disabled" : ""} onClick={finzalizable?saveAction:null}>Finalize & Close</div>
                <div id="saveFinalizeButton" className="non-loading">
                    Save & Finalize 
                    <FaChevronUp />
                    <TailSpin  stroke={'white'} strokeWidth="0.2rem" width={"1rem"} height={"1rem"} />
                </div>
            </div>
        </ButtonsPannel>
        
    </SingleStatement>
    {/* NEW: Navigation buttons with onClick handlers */}
    {(currentStatement?.nextStatementId || (currentStatementId === crntStatement.id && crntStatement.nextStatementId)) ? 
        <div 
            className={`${styles.switchStatementButton} ${styles.rightButton}`}
            onClick={(e) => {
                navigateToNext(e);
            }}
            style={{ pointerEvents: 'auto', userSelect: 'none' }}
        >
            <FaChevronRight />
        </div> 
        : null
    }
    {/* OLD: {crntStatement.nextStatementId ? <div className={`${styles.switchStatementButton} ${styles.rightButton}`}><FaChevronRight /></div> : null} */}
    </div>
}


function filenameFromContentDisposition(header) {
    if (!header) return null;
    const utf8Match = header.match(/filename\*=UTF-8''([^;]+)/i);
    if (utf8Match) {
        try {
            return decodeURIComponent(utf8Match[1]);
        } catch (e) {
            return utf8Match[1];
        }
    }
    const asciiMatch = header.match(/filename="?([^";]+)"?/i);
    return asciiMatch ? asciiMatch[1] : null;
}

function statementPdfDownloadName(statement) {
    const format = (iso) => {
        if (!iso) return "";
        const parts = String(iso).split("-");
        if (parts.length < 3) return iso;
        return `${parts[1]}.${parts[2]}.${String(parts[0]).slice(-2)}`;
    };
    return `Statement ${format(statement?.period?.startDate)}-${format(statement?.period?.endDate)}.pdf`;
}

function triggerBlobDownload(blob, filename) {
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    setTimeout(() => URL.revokeObjectURL(url), 100);
}

function addSpecificLoadToStatement(currentStatement, _setCurrentStatement, addCustomJob){
    const InputFormData = {columns: [
        {
            label: "Load Number",
            name: 'loadNumber',
            mandatory: true,
            suggestionsEnabled: true,
            dataValueRequired : true,
            autoComplete:"off",
            suggestionsLink: API_ROOT+'loads/findLoadByLoadNumber?loadNumber=',
            displayValueGenerator: (val)=>{return `${val["loadNumber"]} (${val['broker']?.["brokerageName"]})`;},
            afterMinimumChars: 2,
        },
        
    ]}
    addPopup({
        content:CustomAddForm,
        popupData:{
            action:(event, postResultAction)=>{
                event.preventDefault();
                const loadData = JSON.parse(event.target['loadNumber'].getAttribute('data-value'));
                const { rate, workingWithDriverPayout } = resolveStatementAddLoadRate(loadData);

                addCustomJob(currentStatement, _setCurrentStatement, {
                    "incompleteLoad": false,
                    "endDate": loadData.endDate,
                    "loadRate": rate,
                    "workingWithDriverPayout": workingWithDriverPayout,
                    "origin": loadData.startCityState,
                    "payout": rate * currentStatement.driver.percentageFromGross,
                    "destination": loadData.endCityState,
                    "loadNumber": loadData.loadNumber,
                    "share": 1,
                    "id": loadData.id
                })
                postResultAction(true);
                // sendRequest("POST", API_ROOT+"statements/regenerateStatementByDriver?driverId="+driverData.id+"&weekStartDate="+weekStartDate, null, (statement)=>{
                    
                //     postResultAction(true);
                //     if(statement){
                //         setOpenStatementsByDrivers({defaultStatementsArray: [statement],
                //             driverIds: [driverData.id]});
                        
                //         setStatementsList(prev => {
                //             const exists = prev.some(item => item.id === statement.id);
                //             return exists ? prev.map(item =>
                //                 item.id === statement.id ? { ...item, status: 'inReview' } : item
                //             ) : [...prev, statement];
                //         });
                //     }
                // }, ()=>{
                //     addNotification({message:`Something went wrong`, type:'alert'});
                //     postResultAction(false);
                // })
            },
            name:"Add",
            formTitle:`Add Load to Statement`,
            submitTitle:`Add`,
            method:"GET",
            columns: InputFormData['columns']
        }, 
        EZCloseAllowed:true
    })
}